import * as actionTypes from "../actions/actionTypes";

const intialState = {
  isLoading: false,
  error: "",
  getCustomerDetails: "",
  passbookDetails: "",
};

const getRemitterDetailsForAccOpenStart = (state) => {
  return {
    ...state,
    isLoading: true,
    getCustomerDetails: "",
    error: "",
  };
};

const getRemitterDetailsForAccOpenSuccess = (state, data) => {
  return {
    ...state,
    getCustomerDetails: data,
    isLoading: false,
    error: "",
  };
};

const getRemitterDetailsForAccOpenFail = (state, err) => {
  return {
    ...state,
    error: err,
    isLoading: false,
  };
};

const YpayReducer = (state = intialState, action) => {
  switch (action.type) {
    case actionTypes.CUSTOMER_DETAILS_BY_CUSTOMER_MOBILE_START:
      return getRemitterDetailsForAccOpenStart(state);
    case actionTypes.CUSTOMER_DETAILS_BY_CUSTOMER_MOBILE_SUCCESS:
      return getRemitterDetailsForAccOpenSuccess(state, action.data);
    case actionTypes.CUSTOMER_DETAILS_BY_CUSTOMER_MOBILE_FAIL:
      return getRemitterDetailsForAccOpenFail(state, action.err);
    case actionTypes.PASSBOOK_DETAILS:
      return {
        ...state,
        passbookDetails: action.data,
      };

    default:
      return state;
  }
};

export default YpayReducer;
